export default {
  value: () => [
    {
      label: 'User',
      name: 'user',
      routePath: 'user',
      databasePath: 'users',
      displayProperty: 'email',
    },
    {
      label: 'Club',
      name: 'club',
      routePath: 'club',
      databasePath: 'clubs',
      displayProperty: 'name',
    },
    {
      label: 'Team',
      name: 'team',
      routePath: 'team',
      databasePath: 'teams',
      displayProperty: 'name',
    },
    {
      label: 'Category',
      name: 'category',
      routePath: 'category',
      databasePath: 'categories',
      displayProperty: 'name',
    },
    {
      label: 'Player',
      name: 'player',
      routePath: 'player',
      databasePath: 'players',
      displayProperty: 'id',
    },
    {
      label: 'Manager',
      name: 'manager',
      routePath: 'manager',
      databasePath: 'managers',
      displayProperty: 'name',
    },
    {
      label: 'Position',
      name: 'position',
      routePath: 'position',
      databasePath: 'positions',
      displayProperty: 'name',
    },
  ],

  get(name) {
    return this.value().find(e => e.name === name);
  },

  findByDatabasePath(databasePath) {
    return this.value().find(e => e.databasePath === databasePath);
  },
};



// WEBPACK FOOTER //
// ./src/entities/entities.js